import React from 'react';
import { motion } from 'framer-motion';
import mediumIcon from '../assets/images/Medium-Icon-Black.svg';
import linkedinIcon from '../assets/images/LI-In-Bug.png';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Name/Brand */}
          <div className="col-span-1 md:col-span-2">
            <motion.h3
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-2xl font-bold gradient-text mb-4"
            >
              Mayank Sharma
            </motion.h3>
            <p className="text-gray-400 mb-6 max-w-md">
              Associate Consultant & Cloud Architect passionate about building 
              scalable data solutions and innovative technologies.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <motion.h4
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-lg font-semibold mb-4"
            >
              Contact Info
            </motion.h4>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="space-y-3 text-gray-400"
            >
              <div className="flex items-center">
                <svg className="w-6 h-6 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>Gurugram, Haryana, India</span>
              </div>
              <div className="flex items-center">
                <svg className="w-6 h-6 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span className="break-all">mayanksharma1232.cl@gmail.com</span>
              </div>
            </motion.div>
          </div>

          {/* Social Media */}
          <div>
            <motion.h4
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="text-lg font-semibold mb-4"
            >
              Follow Me
            </motion.h4>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="flex space-x-4"
            >
              <a
                href="https://www.linkedin.com/in/msweather/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon text-gray-400 hover:text-primary-400"
              >
                <img src={linkedinIcon} alt="LinkedIn" className="w-6 h-6 flex-shrink-0" />
              </a>
              <a
                href="https://medium.com/@msweather"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon text-gray-400 hover:text-primary-400"
              >
                <img src={mediumIcon} alt="Medium" className="w-6 h-6 flex-shrink-0" />
              </a>
            </motion.div>
          </div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400"
        >
          <p>&copy; 2024 Mayank Sharma. All rights reserved.</p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
